module.exports = __webpack_public_path__ + "img/add-icon.d5f90774.svg";